import { render, staticRenderFns } from "./customLabel.vue?vue&type=template&id=0ee97022&scoped=true"
import script from "./customLabel.vue?vue&type=script&lang=js"
export * from "./customLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee97022",
  null
  
)

export default component.exports